import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Button, Grid2 } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { createRequestAction  } from '../actions/LockdownAggregationActions';
import { enqueueSnackbar } from 'actions';

const NewRequestForm = () => {
	const userId = useSelector(state => state.session.user.id);
	const dispatch = useDispatch();
	const [requestName, setRequestName] = useState('');
	const [selectedFile, setSelectedFile] = useState(null);

	const handleFileChange = (e) => {
		setSelectedFile(e.target.files[0]);

		const fileNameWithoutExtension = e.target.files[0].name.split('.').slice(0, -1).join('.');

		const setName = window.confirm(`Insert the name '${fileNameWithoutExtension}' in the cluster name?`);
		
		if (setName) {
			setRequestName(fileNameWithoutExtension);
		}
	};

	const handleSubmit = async () => {
		if (!requestName || !selectedFile) {
			dispatch(enqueueSnackbar({ message: 'Please fill in all fields and select a file.', options: { variant: 'error' } }));
			return;
		}

		const formData = new FormData();
		formData.append('RequestName', requestName);
		formData.append('File', selectedFile);
		formData.append('UserId', userId);

		try {
			await createRequestAction(formData); // Chama a action para excluir
			dispatch(enqueueSnackbar({ message: `Created cluster: ${requestName}`, options: { variant: 'success' } }));

			setSelectedFile(''); // Limpa a seleção
			setRequestName(''); // Limpa a seleção
		} catch (error) {
			dispatch(enqueueSnackbar({ message: `Failed to create cluster: ${error}`, options: { variant: 'error' } }));
		}
	};

	return (
		<Grid2 container spacing={2}>
			<Grid2 item size={12}>
				<TextField
					label="Cluster Name"
					variant="outlined"
					fullWidth
					value={requestName}
					onChange={(e) => setRequestName(e.target.value)}
				/>
			</Grid2>			
			<Grid2 item size={12}>
				<Button
					variant="contained"
					component="label"
					fullWidth
					startIcon={<UploadFileIcon />}
				>
					Upload File
					<input type="file" hidden onChange={handleFileChange} />
				</Button>
			</Grid2>
			<Grid2 item size={12}>
				<Button variant="contained" color="primary" fullWidth onClick={handleSubmit}>
					Submit
				</Button>
			</Grid2>
		</Grid2>
	);
};

export default NewRequestForm;